import type { GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

import type {
  BulletinDigest,
  CompanyList,
  PublicNotice,
} from '@/types/publicNotice'

export { PublicNoticePage as default } from '@/components/pages/Ir/PublicNotice'

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const bulletinDigest: BulletinDigest[] = await wpClient.fetchBulletinDigest()
  const companyList: CompanyList[] = await wpClient.fetchCompanyList()
  const bulletinList: { [key: string]: PublicNotice[] } = {}
  const finalAccountList: { [key: string]: PublicNotice[] } = {}

  for (let i = 0; i < companyList.length; i++) {
    const [bulletin, finalAccount] = await Promise.all([
      wpClient.fetchBulletinList(companyList[i]._id),
      wpClient.fetchFinalAccountList(companyList[i]._id),
    ])

    if (bulletin.length) {
      bulletinList[companyList[i]._id] = bulletin
    } else bulletinList[companyList[i]._id] = []

    if (finalAccount.length) {
      finalAccountList[companyList[i]._id] = finalAccount
    } else finalAccountList[companyList[i]._id] = []
  }
  return {
    props: {
      bulletinDigest: bulletinDigest[0],
      companyList,
      bulletinList,
      finalAccountList,
    },
  }
}
